import UserNotLoggedIn from '@components/common/molecules/UserNotLoggedIn';
import OrderEditViewStore from '@components/order/stores/OrderEditViewStore';
import UserAddressEditViewStore from '@components/user-address/stores/UserAddressEditViewStore';
import { Box, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React from 'react';
import OrderSubmitButton from './OrderSubmitButton';
import AddressOptionList from './address/AddressOptionList';
import OrderInfo from './info/OrderInfo';

interface OrderCartActionProps {
    orderEditViewStore: OrderEditViewStore;
    userAddressEditViewStore: UserAddressEditViewStore;
}

const OrderCartAction: React.FC<OrderCartActionProps> = observer(({ orderEditViewStore, userAddressEditViewStore }) => {
    if (orderEditViewStore.isUserLoggedIn === false) {
        return (
            <Box mt={1}>
                <Typography mb={1} textAlign={"center"}>Prijavi se kako bi mogao naručiti.</Typography>
                <UserNotLoggedIn showRegisterButton={false} />
            </Box>
        )
    }

    return (
        <Box mt={1}>
            <AddressOptionList orderEditViewStore={orderEditViewStore} userAddressEditViewStore={userAddressEditViewStore} />
            <OrderInfo orderEditViewStore={orderEditViewStore} />
            <OrderSubmitButton orderEditViewStore={orderEditViewStore} />
        </Box>
    )
})

export default OrderCartAction;